import { Box, Typography } from "@mui/material";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useJoinState } from "src/components/join/JoinState";
import { TextButton } from "src/components/TextButton";
import TextPageComponent from "src/features/TextPageComponent";
import { theme } from "src/theme/theme";
import { trainwellColor } from "src/theme/themePrimitives";

export const Route = createFileRoute("/join/_layout/inviteCode")({
  component: RouteComponent,
});

function RouteComponent() {
  const invitingUserName = useJoinState((state) => state.invitingUserName);
  const teamCode = useJoinState((state) => state.code);
  const navigate = useNavigate();

  return (
    <TextPageComponent
      chipText={undefined}
      titleText={`Enter your invite code in the Teams tab to join ${invitingUserName}'s team`}
      bodyText="Trainwell app > Teams tab > Join team"
      customComponent={
        <Box
          display="flex"
          flexDirection="column"
          marginTop={2}
          alignItems="center"
        >
          <Box
            component="img"
            src="../assets/teams/empty-teams-tab.jpg"
            alt="Empty teams tab in trainwell app"
            width="80%"
            sx={{
              marginTop: theme.spacing(2),
              marginLeft: theme.spacing(2),
              marginRight: theme.spacing(2),
            }}
          />

          {/* The Overlay Box */}
          <Box
            sx={{
              position: "flex",
              // Position at the bottom.
              bottom: 0,
              width: "100%",
              backgroundColor: trainwellColor.neutral6,
              padding: (theme) => theme.spacing(2, 3),
              borderRadius: theme.spacing(2),
              textAlign: "center",
              // Color of the text.
              color: "white",
            }}
          >
            <Typography variant="subtitle1" component="div">
              Invite code
            </Typography>

            <Typography variant="h4" component="div">
              {teamCode}
            </Typography>
          </Box>
          <TextButton
            sx={{ marginTop: theme.spacing(2) }}
            onClick={() => {
              void navigate({ to: "/create/qrCode" });
            }}
          >
            Don’t have the app?
          </TextButton>
        </Box>
      }
    />
  );
}
